let Rojo = "#DC030E";
let Azul = "#153B5E";
let Celeste = "#07EACE";
let Marron = "#E7A218";
let Blanco = "white";
let Gris = "#909090";
let Verde = "green";

let PrincipalColorFondo = Azul;
let PrincipalColorTexto = Blanco;

let SecundarioColorFondo = Celeste;
let SecundarioColorTexto = Azul;

export const estiloColores = {
  Rojo,
  Azul,
  Celeste,
  Marron,
  Blanco,
  Gris,
  PrincipalColorFondo,
  PrincipalColorTexto,
  SecundarioColorFondo,
  SecundarioColorTexto,
  Verde,
};
